module.exports = __webpack_public_path__ + "img/cooler-master-jacket-preview.59a0891d.png";